import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import PropertyCard from 'components/PropertyCard';
import { useDataLayer } from 'hooks/useDataLayer';
import { usePersonalisation } from 'hooks/usePersonalisation';

const PromoResult = ({ id: propertyId, index, offerId, ...rest }) => {
  const { emitInteractionEvent } = useDataLayer();
  const personalisation = usePersonalisation();

  const handlePropertyLinkOnClick = useCallback(() => {
    const cardNumber = index + 1;
    const customAttributes = { user_event_value: propertyId };
    emitInteractionEvent({ type: 'Promo Area', value: `Card ${cardNumber} Selected`, customAttributes });
    personalisation.trackPromoClick(propertyId);
  }, [personalisation, emitInteractionEvent, index, propertyId]);

  return <PropertyCard {...rest} id={propertyId} featuredOfferId={offerId} inline onClick={handlePropertyLinkOnClick} />;
};

PromoResult.propTypes = {
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  offerId: PropTypes.string.isRequired,
};

export default PromoResult;
